import React from 'react'
import NewsBanner from '../Components/newssection/NewsBanner'
import OutNow from '../Components/newssection/OutNow'
import LatestNews from '../Components/newssection/LatestNews'

function News() {
  return (
   <>
   <NewsBanner />
   <OutNow />
   <LatestNews />
   </>
  )
}

export default News